// src/utils/editorFactory.js
import { Editor } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import Image from '@tiptap/extension-image';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import Gapcursor from '@tiptap/extension-gapcursor';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableHeader from '@tiptap/extension-table-header';
import TableCell from '@tiptap/extension-table-cell';

export function createSimpleEditor(content = '') {
    return new Editor({
        content,
        extensions: [
            StarterKit,
            Underline,
            Link.configure({ openOnClick: false })
        ]
    });
}

export function createRichEditor(content = '', options = {}) {
    // `options` is merged into the tiptap Editor config (backward-compatible —
    // existing callers pass only content). Lets callers attach lifecycle hooks
    // such as onUpdate (e.g. to drive a live preview) without changing the
    // extension set.
    return new Editor({
        content,
        extensions: [
            StarterKit,
            Underline,
            Image,
            Document,
            Paragraph,
            Text,
            Gapcursor,
            Table.configure({ resizable: true }),
            TableRow,
            TableHeader,
            TableCell,
            Link.configure({ openOnClick: false })
        ],
        ...options
    });
}
